// eslint-disable-next-line import/no-extraneous-dependencies
import { OpenAI } from "openai";
import {
  Literal,
  Record as RRecord,
  String as RString,
  Static,
  Union,
} from "runtypes";

import { getNormalEnum } from "./runtypeEnums.js";

export const OpenAIEmbeddingProvider = Literal("OPENAI");
export const BasetenEmbeddingProvider = Literal("BASETEN");
// Provider enum
export const LanceEmbeddingProviderLiteral = Union(
  OpenAIEmbeddingProvider,
  BasetenEmbeddingProvider,
);
export const LanceEmbeddingProvider = getNormalEnum(
  LanceEmbeddingProviderLiteral,
);
export type LanceEmbeddingProvider = Static<
  typeof LanceEmbeddingProviderLiteral
>;

const OpenAIEmbeddingModelLiteral = Union(
  // OpenAI (see https://platform.openai.com/docs/guides/embeddings/embedding-models#embedding-models)
  Literal("text-embedding-3-small"),
  Literal("text-embedding-3-large"),
  Literal("text-embedding-ada-002"),
);
export const OpenAIEmbeddingModel = getNormalEnum(
  OpenAIEmbeddingModelLiteral,
) satisfies Record<
  OpenAI.Embeddings.EmbeddingModel,
  OpenAI.Embeddings.EmbeddingModel
>;
export type OpenAIEmbeddingModel = Static<typeof OpenAIEmbeddingModelLiteral>;

export const BasetenEmbeddingModelLiteral = Union(
  Literal("snowflake-arctic-embed-l-v2.0"),
);
export const BasetenEmbeddingModel = getNormalEnum(
  BasetenEmbeddingModelLiteral,
);
export type BasetenEmbeddingModel = Static<typeof BasetenEmbeddingModelLiteral>;

export const LanceEmbeddingModelLiteral = OpenAIEmbeddingModelLiteral.Or(
  BasetenEmbeddingModelLiteral,
);
export type LanceEmbeddingModel = Static<typeof LanceEmbeddingModelLiteral>;
export const LanceEmbeddingModel = {
  ...OpenAIEmbeddingModel,
  ...BasetenEmbeddingModel,
};

// Provider to models mapping
export const LanceEmbeddingModelMap = {
  [LanceEmbeddingProvider.OPENAI]: OpenAIEmbeddingModel,
  [LanceEmbeddingProvider.BASETEN]: BasetenEmbeddingModel,
};
export type LanceEmbeddingModelMap = typeof LanceEmbeddingModelMap;

export const OpenAIEmbeddingModelProviderKey = RRecord({
  provider: OpenAIEmbeddingProvider,
  model: OpenAIEmbeddingModelLiteral,

  embeddingVersion: RString,
  schemaVersion: RString,
});
export type OpenAIEmbeddingModelProviderKey = Static<
  typeof OpenAIEmbeddingModelProviderKey
>;

export const BasetenEmbeddingModelProviderKey = RRecord({
  provider: BasetenEmbeddingProvider,
  model: BasetenEmbeddingModelLiteral,

  embeddingVersion: RString,
  schemaVersion: RString,
});
export type BasetenEmbeddingModelProviderKey = Static<
  typeof BasetenEmbeddingModelProviderKey
>;

export const DEFAULT_MPK: EmbeddingModelProviderKeyType = {
  model: LanceEmbeddingModelMap.OPENAI["text-embedding-ada-002"],
  provider: LanceEmbeddingProvider.OPENAI,

  embeddingVersion: "0",
  schemaVersion: "0",
};

export const EmbeddingModelProviderKey = OpenAIEmbeddingModelProviderKey.Or(
  BasetenEmbeddingModelProviderKey,
);
export type EmbeddingModelProviderKeyType = Static<
  typeof EmbeddingModelProviderKey
>;

export const LanceTableOfHexesSchemaVersionLiteral = Union(
  Literal("0"),
  Literal("1"),
);
export type LanceTableOfHexesSchemaVersion = Static<
  typeof LanceTableOfHexesSchemaVersionLiteral
>;
export const LanceTableOfHexesSchemaVersionEnum = getNormalEnum(
  LanceTableOfHexesSchemaVersionLiteral,
);

export const LanceTableOfHexesEmbeddingVersionLiteral = Union(Literal("0"));
export type LanceTableOfHexesEmbeddingVersion = Static<
  typeof LanceTableOfHexesEmbeddingVersionLiteral
>;
export const LanceTableOfHexesEmbeddingVersionEnum = getNormalEnum(
  LanceTableOfHexesEmbeddingVersionLiteral,
);

export const LanceTableOfDataSourceColumnsSchemaVersionLiteral = Union(
  Literal("0"),
  Literal("1"),
);
export type LanceTableOfDataSourceColumnsSchemaVersion = Static<
  typeof LanceTableOfDataSourceColumnsSchemaVersionLiteral
>;
export const LanceTableOfDataSourceColumnsSchemaVersionEnum = getNormalEnum(
  LanceTableOfDataSourceColumnsSchemaVersionLiteral,
);

export const LanceTableOfDataSourceColumnsEmbeddingVersionLiteral = Union(
  Literal("0"),
);
export type LanceTableOfDataSourceColumnsEmbeddingVersion = Static<
  typeof LanceTableOfDataSourceColumnsEmbeddingVersionLiteral
>;
export const LanceTableOfDataSourceColumnsEmbeddingVersionEnum = getNormalEnum(
  LanceTableOfDataSourceColumnsEmbeddingVersionLiteral,
);
